import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { Link } from 'core/routing';

import { Avatar } from 'apps/components/shared';

import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

export const Participants = observer(({ participants }) => {
  const participantsList = [];
  participants.forEach(p => {
    participantsList.push(
      <Link
        name='profile'
        params={{ profile: `${p.username}` }}
        key={p.username}
        content={p.content}
      >
        <Participant
          src={imageSrc(
            p.avatar,
            p.imageFallbackPath,
            mainConf.imgSizes.profile.small,
          )}
          size='32px'
        />
      </Link>,
    );
  });
  return <div>{participantsList}</div>;
});

const Participant = styled(Avatar)`
  margin-right: 10px;
  margin-bottom: 10px;
  vertical-align: top;
`;
